import { manifests, dependencies } from './resi-licenses';

export const resiLicenses = {
  manifests,
  dependencies,
};
